import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);

import {MarkerClusterer} from "@googlemaps/markerclusterer";

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initSearch();
            this.initServices();
            this.initProperties();
            this.initMap();
            this.initRecent();
        }
    }

    initSearch() {
        const tabs = document.querySelectorAll('#search .tabs li');
        const tabContents = document.querySelectorAll('#search .tab-content');

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', e => {
                tabs.forEach(tempTab => {
                    tempTab.classList.remove('active');
                });

                tabContents.forEach(tempTabContent => {
                    tempTabContent.classList.remove('active');
                });

                tab.classList.add('active');

                tabContents[i].classList.add('active')
            });
        });
    }

    initServices() {
        new Swiper('#services .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1200: {
                    slidesPerView: 4,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }

    initProperties() {
        new Swiper('#properties .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            // navigation: {
            //     nextEl: '#properties .swiper-button-next',
            //     prevEl: '#properties .swiper-button-prev',
            // }
        });
    }

    initMap() {
        let bounds = new google.maps.LatLngBounds();
        let infowindow = new google.maps.InfoWindow();
        const maps = document.getElementById("maps");

        const map = new google.maps.Map(maps, {
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#b4d4e1"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        });

        const markers = [];

        const properties = maps.dataset.properties;

        JSON.parse(properties).forEach((property, i) => {

            const icon = {
                url: "/img/icon-map.png", // url
                scaledSize: new google.maps.Size(44, 44), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(22, 22) // anchor
            };

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(property.latitude, property.longitude),
                map: map,
                icon: icon
            });

            bounds.extend(marker.position);

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    const infoBubble = new InfoBubble({
                        map: map,
                        content: '<a href="' + property.url + '" class="property infobubble">\n\
                                <figure>\n\
                                    <img src="' + property.hoofdfoto + '" alt="' + property.adres + ' ' + property.plaats + '">\n\
                                    <figcaption style="padding-top: 20px">\n\
                                    <h3>' + property.adres + '</h3>\n\
                                    <p>' + property.plaats.toUpperCase() + '</p>\n\
                                    <p>' + property.oppervlakte + '</p>\n\
                                    <h4>' + property.prijs + '</h4>\n\
                                </figure>\n\
                            </a>',
                        shadowStyle: 0,
                        padding: 0,
                        borderRadius: 0,
                        arrowSize: 0,
                        borderWidth: 0,
                        minWidth: 320,
                        maxWidth: 320,
                        minHeight: 368,
                        closeSrc: '/img/infobubble-close.png'
                    });

                    infoBubble.open(map, marker);
                }
            })(marker, i));

            markers.push(marker);
        });

        map.fitBounds(bounds);

        const renderer = {
            render({count, position}) {
                return new google.maps.Marker({
                    label: {text: String(count), color: "white", fontSize: "12px"},
                    position,
                    icon: {
                        url: "/img/icon-cluster.png", // url
                        scaledSize: new google.maps.Size(60, 60), // scaled size
                        origin: new google.maps.Point(0, 0), // origin
                        anchor: new google.maps.Point(30, 30) // anchor
                    },
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                })
            }
        }

        const markerCluster = new MarkerClusterer({map, markers, renderer});
    }

    initRecent() {
        new Swiper('#recent .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }
}
